import React from 'react';
import { AbsorbingIcon } from '../../../static/svg/AbsorbingIcon';
import { CleansesIcon } from '../../../static/svg/CleansesIcon';
import { CrultyFree } from '../../../static/svg/CrultyFree';
import { FortifiedIcon } from '../../../static/svg/FortifiedIcon';
import { GoldenLeafs } from '../../../static/svg/GoldenLeafs';
import { HalalIcon } from '../../../static/svg/HalalIcon';
import { NoDryIcon } from '../../../static/svg/NoDryIcon';
import { NonGreasyIcon } from '../../../static/svg/NonGreasyIcon';
import { ProvenIcon } from '../../../static/svg/ProvenIcon';
import { VitaminIcon } from '../../../static/svg/VitaminIcon';

export const WhatInIconArray = (className?: string) => {
  let cName = className ? className : '';

  return [
    { name: 'serum', icon: <FortifiedIcon className={cName} /> },
    { name: 'serum', icon: <AbsorbingIcon className={cName} /> },
    { name: 'serum', icon: <VitaminIcon className={cName} /> },
    { name: 'serum', icon: <NonGreasyIcon className={cName} /> },
    { name: 'serum', icon: <HalalIcon className={cName} /> },
    { name: 'serum', icon: <CrultyFree className={cName} /> },
    { name: 'facewash', icon: <CleansesIcon className={cName} /> },
    { name: 'facewash', icon: <AbsorbingIcon className={cName} /> },
    { name: 'facewash', icon: <NoDryIcon className={cName} /> },
    { name: 'facewash', icon: <GoldenLeafs className={cName} /> },
    { name: 'facewash', icon: <HalalIcon className={cName} /> },
    { name: 'facewash', icon: <CrultyFree className={cName} /> },
    { name: 'cream', icon: <ProvenIcon className={cName} /> },
    { name: 'cream', icon: <AbsorbingIcon className={cName} /> },
    { name: 'cream', icon: '' },
    { name: 'cream', icon: <NonGreasyIcon className={cName} /> },
    { name: 'cream', icon: <HalalIcon className={cName} /> },
    { name: 'cream', icon: <CrultyFree className={cName} /> }
  ];
};
